<template>
    <v-dialog v-model="dialog" max-width="600">
        <v-card class="no-padding">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Please enter the changes made for this record:</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row no-gutters>
                        <v-textarea
                            v-model="followupComment"
                        >
                        </v-textarea>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-container>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-alert text type="error" v-if="errorMessage">
                                {{errorMessage}}
                            </v-alert> 
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" md="6" offset-md="3">
                            <v-row>
                                <v-col cols="6">
                                    <v-btn color="primary darken-1" @click="save()" :disabled="saving" :loading="saving" block>Save</v-btn>
                                </v-col>
                                <v-col cols="6">
                                    <v-btn color="warning" @click="cancel()" block>Cancel</v-btn>
                                </v-col>
                            </v-row>
                            <v-spacer></v-spacer>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        medicalRecordID: {
            type: String,
            default: ""
        }    
    } ,
    data() {
        return {
            errorMessage: "",
            saving: false,
            dateMenu: false,
            followupComment: ""
        };
    },
    methods: {
        async save() {
            this.errorMessage = "";
            this.saving = true;
            await this.$emit("save", false, this.followupComment);
            this.saving = false;
            this.dialog = false;
        },
        cancel() {
            this.$emit('cancel');
            this.dialog = false;
        }
    }
}
</script>